// extracted by mini-css-extract-plugin
export default {"wrapper":"cnQrd","arrow":"fjji8","arrowLeft":"MpjmM","arrowRight":"QEmRD","arrowIcon":"rB4eG","images":"vTTJh","dots":"glrtx","dot":"R9uJO","dotActive":"psLsD"};